































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import DeliverySatisfactionSurveyHistoryRequest from '@/model/request/DeliverySatisfactionSurveyHistoryRequest'
import DeliverySatisfactionSurveyHistoryResponse from '@/model/response/DeliverySatisfactionSurveyHistoryResponse'
import FilterDeliverySatisfactionSurveyHistory from '@/components/filters/FilterDeliverySatisfactionSurveyHistory.vue'

const metaInfo = () => ({
title: $.t('view.reports.deliverySatisfactionSurveyHistory.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliverySatisfactionSurveyHistory, FilterToggle},
})
export default class ReportsDeliverySatisfactionSurveyHistoryView extends Mixins(MixinFilter) {
    filter = new DeliverySatisfactionSurveyHistoryRequest()
    collection = new PageCollection(DeliverySatisfactionSurveyHistoryResponse, this.filter, 10)

    AppConfig = AppConfig

    async created() {
      this.collection.orderBy = 'nome'
      this.collection.asc = true
    }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliverySatisfactionSurveyHistoryResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliverySatisfactionSurveyHistory.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliverySatisfactionSurveyHistory.title'),
          new DeliverySatisfactionSurveyHistoryResponse().$endpoint,
          this.filter,
          DeliverySatisfactionSurveyHistoryResponse,
          'DeliverySatisfactionSurveyHistoryResponse',
          ), 'download')
    }
  }
}
